import { apiServer } from 'settings/web-services/api';

export function reassignTasksInBulk(cfg) {
  return apiServer.put('/workshop/task/bulk-reassign', cfg);
}
